import(/* webpackMode: "eager" */ "/app/src/app/(blank-layout)/error.tsx");
